<template>
  <div class="login u-containar-md">
    <HeadingLv2 v-if="!hideHeading" text="パスワードを忘れた方" simple />
    <Alert :text="state.alertMessage" v-if="state.alertMessage" />
    <section>
      <div class="text_area">
        <p>
          パスワードを忘れた場合、パスワードの再設定が必要です。パスワードを再設定するためのURLをお送りしますので、メールアドレスを入力して、パスワードをリセットしてください。
        </p>
      </div>
    </section>

    <section>
      <div class="reset">
        <form action="/password/email" method="POST" class="login_form">
          <input type="hidden" name="_token" :value="csrf" />
          <input type="hidden" name="q" :value="state.q" />

          <FormInputField
            id="mail"
            name="email"
            :value="user.email"
            :error="validations.email.isError"
            :error-message="validations.email.errorMessage"
            label="メールアドレス"
            @change-message="changeMessage('email', $event)"
            placeholder="例：abd@example.com"
            req
          />

          <FormBirthDate
            name="birthday"
            :value="user.birthday"
            :error="validations.birthday.isError"
            :error-message="validations.birthday.errorMessage"
            :fullYear="user.birthday"
            label="生年月日"
            @selection-change="changeMessage('birthday', $event)"
            req
          />

          <div v-if="Object.keys(validation.errors).length">
            <span style="color: red;"
              >入力内容に誤りがあるので確認してください</span
            >
            <template
              v-for="(v, key, index) in validation.errors.message"
              :key="index"
            >
              <Alert :text="v.toString()" inline />
            </template>
          </div>

          <div class="reset_btnArea">
            <Button
              label="パスワードをリセットする"
              :handleClick="resetSubmit"
              :disabled="isDisabledNextBtn"
            />
          </div>
        </form>
      </div>
    </section>
  </div>
</template>

<script lang="ts">
import HeadingLv2 from '@/components/elements/HeadingLv2.vue'
import SnsRegistButtons from '@/components/block/SnsRegistButtons.vue'
import FormInputField from '@/components/block/FormInputField.vue'
import FormBirthDate from '@/components/block/FormBirthDate.vue'
import CheckboxButton from '@/components/elements/InputCheckboxButton.vue'
import Alert from '@/components/elements/Alert.vue'
import Button from '@/components/elements/Button.vue'
// import TextLink from '@/components/elements/TextLink.vue'
import { reactive, ref, onMounted, computed } from 'vue'
import axios from 'axios'
import { axiosSetting } from '@/utils/axiosSetting'
import { PasswordResetUser } from '@/types/PasswordResetUser'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { applyValidation } from '@/utils/validation'

export default {
  name: 'PasswordResetIndex',

  props: {
    hideHeading: {
      type: Boolean,
      default: false
    },
    redirect: {
      type: String,
      default: ''
    }
  },

  components: {
    HeadingLv2,
    FormInputField,
    FormBirthDate,
    Alert,
    Button
    // TextLink
  },

  setup(props: any) {
    const store = useStore()
    const router = useRouter()

    const csrf = ref(
      document.querySelector('meta[name="csrf-token"]')!.getAttribute('content')
    )

    const user = reactive<PasswordResetUser>({
      email: '',
      birthday: ''
    })

    const state = reactive<{ alertMessage: string; q: string }>({
      alertMessage: '',
      q: ''
    })

    let isBirthDayInputCompleteOnce = false

    if (user.birthday) {
      const arr = user.birthday.split('/')
      if (arr[0] && arr[1] && arr[2]) isBirthDayInputCompleteOnce = true
    }

    interface ValidationsObject {
      [key: string]: any
    }

    const validations: ValidationsObject = reactive({
      email: {
        rules: ['required', 'email'],
        isError: false,
        errorMessage: ''
      },
      birthday: {
        rules: ['required', 'date'],
        isError: false,
        errorMessage: ''
      }
    })
    const validation = reactive({
      errors: {}
    })
    const resetSubmit = async () => {
      store.commit('showLoading')
      try {
        const response = await axios.post('/api/checkPasswordResettableUser', {
          email: user.email,
          birthday: user.birthday,
          _token: csrf
        })
        const form: any = document.querySelector('.login_form')!
        console.log('store_index', store.state)

        const params: any = {
          email: user.email,
          birthday: user.birthday,
          _token: csrf.value
        }

        const ajax = axiosSetting('app', 'action')
        ajax
          .post('/password/email', params)
          .then((res) => {
            store.commit('setPasswordToken', true)
            router.push({
              path: `/password/Sendmail`
            })
          })
          .catch((errors: any) => {
            if (errors.response.data) {
              const errorInfo = errors.response.data
              Object.keys(errorInfo).forEach((key) => {
                // リダイレクト（パスワードが空の場合)
                if (key == 'redirect') {
                  // TODO: メッセージ追加
                  // リダイレクトする
                  router.push(errorInfo[key])
                } else if (key == 'alert') {
                  alert(errorInfo[key])
                }

                if (validations[key]) {
                  validations[key].isError = true
                  validations[key].errorMessage = errorInfo[key]
                }
              })
            }
          })

        return false
      } catch (errors) {
        store.commit('closeLoading')
        if (errors.response.data) {
          const errorInfo = errors.response.data
          Object.keys(errorInfo).forEach((key) => {
            // リダイレクト（パスワードが空の場合)
            if (key == 'redirect') {
              // TODO: メッセージ追加
              // リダイレクトする
              router.push(errorInfo[key])
            } else if (key == 'alert') {
              alert(errorInfo[key])
            }

            if (validations[key]) {
              validations[key].isError = true
              validations[key].errorMessage = errorInfo[key]
            }
          })
        }
      }
    }

    const changeMessage = (name: string, value: string) => {
      console.log(name, value)

      if (name === 'birthday' && value) {
        const arr = value.split('/')
        // 入力値がどこか空だったら
        if (!arr[0] || !arr[1] || !arr[2]) {
          if (isBirthDayInputCompleteOnce) {
            value = '' // 一度全て入力している場合は必須エラーになるように
          } else {
            return // 一度も入力完了していない場合はエラーにしない
          }
        }
        // 全て入力完了したらフラグをtrueに
        if (arr[0] && arr[1] && arr[2]) {
          isBirthDayInputCompleteOnce = true
        }
      }

      const result = applyValidation(validations[name].rules, value)

      validations[name].isError = result.isError
      validations[name].errorMessage = result.message
      user[name] = value
    }

    onMounted(async () => {
      const params = new URLSearchParams(location.search)
      const query = params.get('throw')
      if (query === 'line') {
        state.alertMessage = 'ご利用のSNSアカウントでは会員登録されていません。'
      }

      const q = params.get('q')
      if (q) {
        state.q = q
      }
      if (props.redirect) {
        state.q = props.redirect
      }
    })

    const registerPath = computed(() => {
      const base = '/register/user_category'
      return state.q ? `${base}?q=${state.q}` : base
    })

    // 確認ボタンの活性・非活性制御
    const isDisabledNextBtn = computed(() => {
      if (user.email === '' || user.birthday === '') {
        return true
      }

      const arr: Array<string> = Object.keys(validations)

      for (let i = 0; i < arr.length; i++) {
        if (validations[arr[i]].isError) return true
      }

      return false
    })

    return {
      resetSubmit,
      csrf,
      user,
      changeMessage,
      validation,
      validations,
      state,
      registerPath,
      isDisabledNextBtn
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

html,
body {
  height: 100%;
  width: 100%;
  overflow: auto;
}

.text_area {
  padding-bottom: 40px;
}

.reset {
  &_btnArea {
    margin-top: 30px;
    padding-left: 20px;
    padding-right: 20px;
    text-align: center;

    &_link {
      margin-top: 25px;
      display: inline-block;
    }

    &_text {
      margin-bottom: 20px;
    }
  }
}

input[type='text'] {
  font-size: 16px;
  transform: scale(0.8);
}

select {
  font-size: 16px;
  transform: scale(0.8);
}
</style>
